module.exports = __webpack_public_path__ + "img/T006_150ppi.a4fa295a.png";